import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "story-page-content" };
import { ref, onMounted, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import MGWalkthrough from './elements/MGWalkthrough.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StoryPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getWalkthrough } = useContent();
        const { getCustomer } = useCustomer();
        const { getOpenBankingLinkUrl } = useBanking();
        const walkthroughTitle = ref('');
        const walkthroughData = ref(null);
        const currentSlideIndex = ref(0);
        const walkthrough = useTemplateRef('walkthrough');
        function loadWalkthroughData() {
            const walkthroughId = (route.params.id || route.query.id);
            if (walkthroughId) {
                getWalkthrough(walkthroughId, (result) => {
                    walkthroughData.value = result;
                });
            }
        }
        function handleBack() {
            if (currentSlideIndex.value === 0) {
                router.back();
            }
            else {
                walkthrough.value?.goToPreviousSlide();
            }
        }
        function handleTitleLoaded(title) {
            walkthroughTitle.value = title;
        }
        function handleSlideIndexChanged(index) {
            currentSlideIndex.value = index;
        }
        function determineCarouselHeight() {
            if (window.innerHeight < 700) {
                return '240px';
            }
            else {
                return '370px';
            }
        }
        function handleActionClicked(actionUri) {
            if (actionUri && actionUri.includes('*truelayer*')) {
                handleLinkAccount();
                return;
            }
            if (actionUri) {
                router.push(actionUri);
            }
        }
        function handleLinkAccount() {
            document.body.classList.remove('hide-nav-bar');
            if (!state.customer) {
                getCustomer(() => {
                    const navTo = getOpenBankingLinkUrl(state.customer.id);
                    window.open(navTo, '_blank');
                });
            }
            else {
                const navTo = getOpenBankingLinkUrl(state.customer.id);
                window.open(navTo, '_blank');
            }
        }
        onMounted(() => {
            loadWalkthroughData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: walkthroughTitle.value,
                    logicalBack: true,
                    onLogicalBack: _cache[0] || (_cache[0] = ($event) => (handleBack()))
                }, null, 8, ["title"]),
                _createElementVNode("div", _hoisted_1, [
                    (walkthroughData.value)
                        ? (_openBlock(), _createBlock(MGWalkthrough, {
                            key: 0,
                            ref_key: "walkthrough",
                            ref: walkthrough,
                            walkthroughData: walkthroughData.value,
                            variant: "story",
                            imageHeight: '350',
                            height: determineCarouselHeight(),
                            onSlideTitleChanged: handleTitleLoaded,
                            onSlideIndexChanged: handleSlideIndexChanged,
                            onCloseDrawer: _cache[1] || (_cache[1] = ($event) => (_unref(router).back())),
                            onActionClicked: handleActionClicked
                        }, null, 8, ["walkthroughData", "height"]))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
